<!--
    描述：项目结构右侧 动态表单
    时间：2020-05-27
    Created by ws
-->
<template>
	<div class="right-structure-main">
		<div class="overflow-y h100 right-container">
			<!-- 动态模板生成 -->
			<div class="baseForm-layout"
				 v-for="(item, index) in templateList"
				 :key="'模板' + index"
				 v-show="!item.hidden || item.blockType === '1031001' || item.blockType === '1031002' || item.blockType === '1031020'">
				<div class="baseForm-header overflow-hidden">{{ item.sname }}
					<div class="align-btn">
						<el-button v-if="item.blockType === '1031002'"
								   size="mini"
								   type="primary"
								   @click="handleTool('sync', item)">同步数据
						</el-button>
					</div>
				</div>
				<div class="baseForm-content">
					<!-- 普通平级 2-2 分布 -->
					<el-form v-if="item.usualFieldList.length > 0">
						<el-row>
							<el-col :span="12"
									v-for="(m, n) in item.usualFieldList"
									:key="'字段' + n">
								<!-- 公共字段 -->
								<public-field :currentObj="m"
											  :labelWidth="item.specialBlockList.length > 0 ? '110px' : '160px'"
											  :isDisabled="isDisabled"
											  @changeShow="changeShow"></public-field>
							</el-col>
						</el-row>
					</el-form>

					<!-- 树结构处理 1-4 1-3等 分布-->
					<template v-if="item.specialBlockList.length > 0">
						<el-form>
							<el-row v-for="(m, n) in item.specialBlockList"
									:key="'tree结构' + index + n">
								<el-col style="width: 92%">
									<!-- 公共字段 -->
									<public-field :currentObj="m"
												  labelWidth="110px"
												  :isDisabled="isDisabled"
												  @changeShow="changeShow"></public-field>
								</el-col>
								<el-col class="text-right"
										style="width: 8%"
										v-if="n !== 0">
									<el-button icon="el-icon-delete"
											   type="primary"
											   :disabled="isDisabled"
											   @click="doDelete('block', item.specialBlockList, null, n)"></el-button>
								</el-col>

								<!-- 子级 -->
								<el-col :span="24"
										v-for="delItem in m.children.length / m.colSpan"
										:key="'删除' + delItem">
									<el-col v-if="m.children.length > 0"
											:style="{'width': 92/m.colSpan + '%'}"
											v-for="(levelItem, levelIndex) in calcCols(m.children, m.colSpan, delItem)"
											:key="levelItem.title + levelIndex">
										<!-- 公共字段 -->
										<public-field :currentObj="levelItem"
													  labelWidth="110px"
													  :isDisabled="isDisabled"
													  @changeShow="changeShow"></public-field>
									</el-col>
									<el-col class="text-right"
											style="width: 8%"
											v-if="delItem !== 1">
										<el-button icon="el-icon-delete"
												   :disabled="isDisabled"
												   @click="doDelete('row', m.children, m.colSpan, delItem)"></el-button>
									</el-col>
								</el-col>

								<!-- 添加区块内 子元素 -->
								<el-col :span="24">
									<el-form-item label-width="110px">
										<el-button icon="el-icon-plus"
												   size="mini"
												   type="primary"
												   :disabled="isDisabled"
												   @click="addRow(m)">添加行
										</el-button>
									</el-form-item>
								</el-col>
							</el-row>

							<!-- 添加区块 -->
							<el-row>
								<el-col :span="24">
									<el-button icon="el-icon-plus"
											   size="small"
											   :disabled="isDisabled"
											   @click="addBlock(item.specialBlockList)">添加结构块
									</el-button>
								</el-col>
							</el-row>
						</el-form>
					</template>

					<!-- 无父级 list 处理 -->
					<template v-if="item.commonBlockList.length > 0">
						<el-form>
							<el-row v-for="delItem in item.commonBlockList.length / item.commonBlockList[0].parentCol"
									:key="'删除common' + delItem">
								<el-col :style="{'width': 92/item.commonBlockList[0].parentCol + '%'}"
										v-for="(levelItem, levelIndex) in calcCols(item.commonBlockList, item.commonBlockList[0].parentCol, delItem)"
										:key="levelItem.title + levelIndex">
									<!-- 公共字段 -->
									<public-field :currentObj="levelItem"
												  labelWidth="110px"
												  :isDisabled="isDisabled"
												  @changeShow="changeShow"></public-field>
								</el-col>
								<el-col class="text-right"
										style="width: 8%"
										v-if="delItem !== 1">
									<el-button icon="el-icon-delete"
											   :disabled="isDisabled"
											   @click="doDelete('row', item.commonBlockList, item.commonBlockList[0].parentCol, delItem)">
									</el-button>
								</el-col>
							</el-row>
							<el-row>
								<!-- 添加list 元素 -->
								<el-col :span="24">
									<el-form-item label-width="110px">
										<el-button icon="el-icon-plus"
												   size="mini"
												   type="primary"
												   :disabled="isDisabled"
												   @click="addList(item.commonBlockList)">添加行
										</el-button>
									</el-form-item>
								</el-col>
							</el-row>
						</el-form>
					</template>
				</div>
			</div>
		</div>

		<!-- 右侧按钮组 -->
		<div class="right-btns" v-if="!hideBtn">
			<el-button size="small"
					   type="primary"
					   class="zIndex"
					   v-if="roleBtns.includes('structure-lock') || curSource === '1'"
					   @click="handleTool('isLock')">
				{{ isDisabled ? '解锁' : '锁定' }}
			</el-button>
			<el-button size="small"
					   class="mt10 ml0 zIndex"
					   type="primary"
					   :loading="btnLoading"
					   v-if="roleBtns.includes('structure-save') || curSource === '1'"
					   @click="handleTool('save')">保存
			</el-button>
			<el-button size="small"
					   class="mt10 ml0 zIndex"
					   type="primary"
					   :loading="btnLoading"
					   v-if="roleBtns.includes('structure-export') || curSource === '1'"
					   @click="handleTool('export')">导出
			</el-button>
		</div>

		<!-- 导出弹窗 -->
		<el-dialog :visible.sync="dialogObj.visible"
				   :title="dialogObj.title"
				   :width="dialogObj.width"
				   :close-on-click-modal="false">
			<!-- 导出弹窗 -->
			<template v-if="dialogObj.visible && dialogObj.type === 'export'">
				<div class="block-item">导出格式：
					<el-radio v-model="exportType"
							  label="excel">excel
					</el-radio>
					<el-radio v-model="exportType"
							  label="html">html
					</el-radio>
				</div>
				<div class="block-item mt10">导出模块：
					<el-checkbox :indeterminate="isIndeterminate"
								 v-model="checkAll"
								 @change="handleCheckAllChange($event, 'export')">全选
					</el-checkbox>
					( 注意： 基本信息模块默认导出 )
					<el-checkbox-group v-model="checkedBlock"
									   @change="handleCheck($event, 'export')"
									   style="padding-left: 74px">
						<el-checkbox v-for="(item, index) in blockList"
									 :label="item.id"
									 :key="item.id"
									 :disabled="item.disabled">{{ item.sname }}
						</el-checkbox>
					</el-checkbox-group>
				</div>
			</template>

			<!-- 同步数据弹窗 -->
			<template v-if="dialogObj.visible && dialogObj.type === 'sync'">
				<el-checkbox :indeterminate="isIndeterminate"
							 v-model="checkAll"
							 @change="handleCheckAllChange($event, 'sync')">全选
				</el-checkbox>
				<el-checkbox-group v-model="checkedTreeIds"
								   @change="handleCheck($event, 'sync')">
					<el-checkbox v-for="(item, index) in unitList"
								 :label="item.id"
								 :key="item.id">{{ item.sname }}
					</el-checkbox>
				</el-checkbox-group>
				<div class="info-text mt10">注意：同步数据会将当前结构信息数据同步到所勾选的单项工程，<br />
					若当前结构信息为空，则同步后所勾选单项工程结构信息一并清空！
				</div>
			</template>

			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="dialogObj.mode !== 'view'">
				<el-button size="small"
						   @click="dialogObj.visible = false">取 消
				</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="dialogObj.btnLoading"
						   @click="doSave">确 定
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { saveBasicInfoSingleProjects } from '@/api/modules/analysis'
import {
	baseInfoExportExcel,
	getStructureData,
	doSyncData
} from '@/api/modules/dataProject'
import { mapState } from 'vuex'
import publicField from './public_field'
import { exportExcel, dateFormat } from '@/utils/tools'

export default {
	props: {
		// 动态表单数据
		resData: {
			type: Array,
			default: () => {
				return []
			}
		},
		// 当前节点id
		curRowId: {
			type: String,
			default: ''
		},
		// curRangeType
		curRangeType: {
			type: String,
			default: ''
		},
		// 是否不可编辑
		hideBtn: {
			type: Boolean,
			default: false
		}
	},
	components: {
		publicField
	},
	data() {
		return {
			// 动态表单 数组
			templateList: [],
			showList: [], // 展示的区块数组
			// 是否可编辑
			isDisabled: true,
			// 按钮等待状态
			btnLoading: false,
			dialogObj: {
				visible: false,
				type: 'export',
				width: '700px',
				title: '导出项确认',
				btnLoading: false
			},
			exportType: 'excel', // 导出格式
			isIndeterminate: false,
			checkAll: false,
			blockList: [], // 所有区块数组
			checkedBlock: [], // 所选的导出区块
			unitList: [], // 单项工程数组
			checkedTreeIds: [],
			// 同步数据的参数
			syncObj: {}
		}
	},
	methods: {
		// 控制锁定 解锁
		handleTool(type, item) {
			switch (type) {
				case 'isLock':
					this.isDisabled = !this.isDisabled
					break
				case 'save':
					this.saveData()
					break
				case 'export':
					this.blockList = []

					let _list = this.templateList || []
					this.blockList.push(..._list)

					this.dialogObj.visible = true
					this.dialogObj.type = 'export'
					this.dialogObj.title = '导出项确认'
					break
				case 'sync':
					this.dialogObj.visible = true
					this.dialogObj.type = 'sync'
					this.dialogObj.title = '同步数据 到 相同类型单项工程'

					this.syncObj = item
					this.getUnitList()
			}
		},

		// 执行保存
		saveData() {
			this.btnLoading = true
			let params = Object.assign([], this.templateList)

			saveBasicInfoSingleProjects(params)
				.then(res => {
					setTimeout(() => {
						this.btnLoading = false
					}, 2000)
					if (res.operationCode == 1) {
						this.$message.success('保存成功!')
						this.isDisabled = true
					}
				})
				.catch(err => {
					// console.log(err)
					// this.$message.error(err)
					setTimeout(() => {
						this.btnLoading = false
					}, 2000)
				})
		},

		// 获取单项工程列表
		getUnitList() {
			getStructureData({
				id: this.curProjectId
			}).then(res => {
				let arr = res.data.children.filter(
					x => x.levelTypeCode === this.curRangeType
				)
				this.unitList = arr
			})
		},

		// 导出弹窗 --- 切换全选按钮
		handleCheckAllChange(val, type) {
			if (type === 'export') {
				let _list = this.blockList.map(x => x.id)
				this.checkedBlock = val ? _list : []
			} else {
				let _list = this.unitList.map(x => x.id)
				this.checkedTreeIds = val ? _list : []
			}

			this.isIndeterminate = false
		},

		// 导出弹窗 --- 切换每一个区块
		handleCheck(arr, type) {
			let checkedCount = arr.length
			if (type === 'export') {
				this.checkAll = checkedCount === this.blockList.length
				this.isIndeterminate =
					checkedCount > 0 && checkedCount < this.blockList.length
			} else {
				this.checkAll = checkedCount === this.unitList.length
				this.isIndeterminate =
					checkedCount > 0 && checkedCount < this.unitList.length
			}
		},

		// 导出弹窗 --- 确认导出
		doSave() {
			this.dialogObj.btnLoading = true
			let saveName = '项目结构' + dateFormat('yyyy-MM-dd hh:ss:mm')
			// 导出
			if (this.dialogObj.type === 'export') {
				let params = {
					ids: this.checkedBlock,
					id: this.curProjectId,
					exportType: this.exportType,
					contractTreeId: this.curRowId,
					rangeType: this.curRangeType,
					saveName: saveName
				}
				exportExcel(
					'analysisFormTemplate/exportProjectStructure',
					params,
					saveName
				)
			} else {
				// 同步数据
				let params = JSON.parse(JSON.stringify(this.syncObj))
				params.treeIds = this.checkedTreeIds

				// console.log(params)
				// this.$message.warning('接口测试中....')
				doSyncData(params)
					.then(res => {
						if (res.code === 0) {
							this.$message.success('保存成功')
						}
					})
					.catch(err => {})
			}

			setTimeout(() => {
				this.dialogObj.visible = false
				this.dialogObj.btnLoading = false
			}, 1000)
		},

		// 动态展示区块
		changeShow(arr) {
			this.templateList.map(x => {
				x.hidden = true
				if (arr.includes(x.blockType)) {
					x.hidden = false
				}
			})
			// this.showList = arr
			// console.log(this.showList)
		},

		// 添加区块内部 块
		addBlock(arr) {
			// 父级
			let _item = Object.assign({}, arr[0])
			_item.children = []
			_item.value = null
			_item.rowIndex = arr.length + 1
			_item.sort = arr.length + 1

			// 子级
			let _child = arr[0].children.slice(0, arr[0].colSpan)
			_child.map(x => {
				let obj = JSON.parse(JSON.stringify(x))
				obj.value = null
				obj.pid = _item.sort
				_item.children.push(obj)
			})

			// 放入数组
			arr.push(_item)
		},

		// 添加行
		addRow(item) {
			// 找到要添加的 数组
			let _arr = item.children.slice(0, item.colSpan)
			// 找到最后一个 rowIndex
			let _index = item.children[item.children.length - 1].rowIndex

			_arr.map(x => {
				let obj = JSON.parse(JSON.stringify(x))
				obj.rowIndex = _index + 1
				obj.value = ''
				item.children.push(obj)
			})
		},

		// 添加 同级 list
		addList(list) {
			let _index = list[list.length - 1].rowIndex + 1
			// 找到要添加的 数组
			let _arr = list.filter(x => x.rowIndex === 1)

			_arr.map(x => {
				let obj = JSON.parse(JSON.stringify(x))
				obj.rowIndex = _index
				obj.sort = list.length + 1
				obj.value = ''
				list.push(obj)
			})
		},

		// 计算展示
		calcCols(children, colSpan, index) {
			return children.slice(colSpan * (index - 1), colSpan * index)
		},

		// 区块内部删除
		doDelete(type, arr, colSpan, index) {
			switch (type) {
				case 'row':
					arr.splice(colSpan * (index - 1), colSpan)
					break
				case 'block':
					arr.splice(index, 1)
			}
		}
	},
	computed: {
		// 当前的 项目来源：'0' 是造价系统的， '1' 是审计系统推送的
		curSource() {
			return this.$route.query.source || '0'
		},
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		}),
		// 当前项目ID
		curProjectId() {
			return this.$route.query.projectId
		},
	},
	watch: {
		resData(arr) {
			if (arr.length > 0) {
				arr.map(x => {
					x.hidden = false
				})
				this.templateList = JSON.parse(JSON.stringify(arr))
			} else {
				this.templateList = []
			}
		}
	}
}
</script>

<style scoped lang="less">
.right-structure-main {
	height: 100%;
	padding: 0 10px;
	overflow-x: hidden;
	overflow-y: auto;
	position: relative;
	background-color: #fff;

	.right-container {
		position: absolute;
		top: 0;
		left: 10px;
		right: 0;
		bottom: 0;
		z-index: 2;
	}

	.right-btns {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: 0 10px;

		.zIndex {
			z-index: 5;
		}
	}

	.align-btn {
		display: flex;
		align-items: center;
		margin-left: 20px;
	}
}

/deep/ .block-item {
	line-height: 30px;
}

.info-text {
	height: 50px;
	line-height: 30px;
	color: red;
}
</style>
